import { defineStore } from 'pinia';
import api from '@/services/api';

export const PREFIJO_TIPO_TINTA_DEFECTO_PROCESO = 'tipo_tinta_defecto_proceso_';
export const PREFIJO_TINTA_DEFECTO_PROCESO = 'tinta_defecto_proceso_';
export const PREFIJO_COBERTURA_TINTA_DEFECTO_PROCESO = 'cobertura_tinta_defecto_proceso_';
export const PREFIJO_COBERTURA_BARNIZ_DEFECTO_PROCESO = 'cobertura_barniz_defecto_proceso_';
export const PREFIJO_BARNIZ_DEFECTO_PROCESO = 'barniz_defecto_proceso_';

function obtenerValorNumerico(state, claveInterna) {
  const configuracion = state.configuraciones.find((c) => c.ClaveInterna === claveInterna);
  if (!configuracion) return null;
  const texto = (configuracion.Valor ?? '').toString().trim();
  if (!texto) return null;
  const numero = Number(texto);
  return Number.isNaN(numero) ? null : numero;
}

export const useConfiguracionesPorDefectoStore = defineStore('configuracionesPorDefectoStore', {
  state: () => ({
    entity: 'configuraciones-por-defecto',
    configuraciones: [],
  }),
  getters: {
    utilidadGeneral: (state) => obtenerValorNumerico(state, 'utilidad_general'),
    porcentajeIvaPredeterminado: (state) =>
      obtenerValorNumerico(state, 'porcentaje_iva_predeterminado'),
    coberturaTinta: (state) => obtenerValorNumerico(state, 'cobertura_tinta'),
    coberturaBarniz: (state) => obtenerValorNumerico(state, 'cobertura_barniz'),
    lateralesImposicion: (state) => obtenerValorNumerico(state, 'laterales_imposicion'),
    gapEjeImposicion: (state) => obtenerValorNumerico(state, 'gap_eje_imposicion'),
    gapDesarrolloImposicion: (state) => obtenerValorNumerico(state, 'gap_desarrollo_imposicion'),
    tolMedidaAnchoMin: (state) => obtenerValorNumerico(state, 'tol_medida_ancho_min'),
    tolMedidaAnchoMax: (state) => obtenerValorNumerico(state, 'tol_medida_ancho_max'),
    tolMedidaDesarrolloMin: (state) => obtenerValorNumerico(state, 'tol_medida_desarrollo_min'),
    tolMedidaDesarrolloMax: (state) => obtenerValorNumerico(state, 'tol_medida_desarrollo_max'),
    tolGapAnchoMin: (state) => obtenerValorNumerico(state, 'tol_gap_ancho_min'),
    tolGapAnchoMax: (state) => obtenerValorNumerico(state, 'tol_gap_ancho_max'),
    tolGapDesarrolloMin: (state) => obtenerValorNumerico(state, 'tol_gap_desarrollo_min'),
    tolGapDesarrolloMax: (state) => obtenerValorNumerico(state, 'tol_gap_desarrollo_max'),
    tipoTintaDefectoPorProceso: (state) => (codigoProceso) =>
      obtenerValorNumerico(state, `${PREFIJO_TIPO_TINTA_DEFECTO_PROCESO}${codigoProceso}`),
    coberturaTintaPorProceso: (state) => (codigoProceso) =>
      obtenerValorNumerico(state, `${PREFIJO_COBERTURA_TINTA_DEFECTO_PROCESO}${codigoProceso}`) ??
      obtenerValorNumerico(state, 'cobertura_tinta'),
    coberturaBarnizPorProceso: (state) => (codigoProceso) =>
      obtenerValorNumerico(state, `${PREFIJO_COBERTURA_BARNIZ_DEFECTO_PROCESO}${codigoProceso}`) ??
      obtenerValorNumerico(state, 'cobertura_barniz'),
    tintaDefectoPorProceso: (state) => (codigoProceso) => {
      const configuracion = state.configuraciones.find(
        (c) => c.ClaveInterna === `${PREFIJO_TINTA_DEFECTO_PROCESO}${codigoProceso}`,
      );
      const material = configuracion?.Material;
      return material?.Codigo && material.Activo !== false ? material : null;
    },
    barnizDefectoPorProceso: (state) => (codigoProceso) => {
      const configuracion = state.configuraciones.find(
        (c) => c.ClaveInterna === `${PREFIJO_BARNIZ_DEFECTO_PROCESO}${codigoProceso}`,
      );
      const material = configuracion?.Material;
      return material?.Codigo && material.Activo !== false ? material : null;
    },
  },
  actions: {
    async findAllHTTP() {
      const result = await api.get(`/${this.entity}`);
      this.configuraciones = Array.isArray(result.data) ? result.data : [];
      return this.configuraciones;
    },
    async updateHTTP(claveInterna, valor) {
      const result = await api.patch(`/${this.entity}/${claveInterna}`, {
        Valor: valor === null || valor === undefined ? '' : String(valor),
      });
      const index = this.configuraciones.findIndex((c) => c.ClaveInterna === claveInterna);
      if (index !== -1) this.configuraciones[index] = result.data;
      return result.data;
    },
    async findOverridesByElementoTipoHTTP(codigoElementoTipo) {
      const result = await api.get(`/${this.entity}/elemento-tipo/${codigoElementoTipo}`);
      return Array.isArray(result.data) ? result.data : [];
    },
    async updateOverridesByElementoTipoHTTP(codigoElementoTipo, overrides) {
      const result = await api.patch(`/${this.entity}/elemento-tipo/${codigoElementoTipo}`, {
        overrides,
      });
      return result.data;
    },
  },
});
